import React from 'react';

const OriginalsIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15 1.32135V15.3214H10.0222V10.2914C10.0222 9.97009 9.86779 9.66831 9.60714 9.48035L8.58492 8.74317C8.23565 8.49129 7.76435 8.49129 7.41508 8.74317L6.39286 9.48035C6.13221 9.66831 5.97778 9.97009 5.97778 10.2914V15.3214H1V1.32351H5.97778V6.52074H10.0222V1.32135H15Z",
      stroke: "white"
    }
  )
);
OriginalsIcon.displayName = "Icons.OriginalsIcon";

export { OriginalsIcon };
//# sourceMappingURL=OriginalsIcon.js.map
